import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
@Injectable()
export class PortalConfig {
  get publicConfig (): any {
    return environment.PUBLIC_CONFIG;
  }
}
